import { requestPasswordRequestApi } from '@ax/service';
import { useQuery } from '@tanstack/react-query';

export function useRequestPasswordResetApi(email?: string | undefined | null) {
  const query = useQuery({
    queryKey: ['request-password-reset', email],
    queryFn: () => {
      if (email) {
        return requestPasswordRequestApi({ email });
      } else {
        return Promise.resolve({});
      }
    },
    onError: (error: any) => {
      console.log(error.message);
    },
    enabled: true,
    cacheTime: 0,
  });
  return query;
}
